export default __webpack_public_path__ + "static/media/wishlist-black.48438041.svg";